import Loader from "./Loader";

const FullPageLoader = () => {
  return (
    <div className="flex flex-col min-h-screen items-center justify-center">
      <Loader />
    </div>
  )
};

export default FullPageLoader;
